const clientParams = ["client_id", "redirect_uri", "response_type", "scope", "scopes", "state", "nonce"];

// Inside an embedded app's iframe, Microsoft sign-in can never finish: Microsoft refuses to be framed, and the browser drops
// the AuthServer's sign-in cookie on the cross-site callback, so the frame loops between the two. Sign in at the top level
// for the default (portal) client instead; the fresh SSO session then signs the embedded app in silently.
export const startMicrosoftSignIn = (signInUrl: string): void => {
  const top = window.top;
  if (!top || top === window.self) {
    window.location.replace(signInUrl);
    return;
  }

  const url = new URL(signInUrl, window.location.href);
  for (const param of clientParams) {
    url.searchParams.delete(param);
  }
  top.location.replace(url.toString());
};
